import { QuestionCircleOutlined } from '@ant-design/icons';
import { SelectLang as UmiSelectLang, useModel } from '@umijs/max';
import { Switch } from 'antd';

export type SiderTheme = 'light' | 'dark';

export const SelectLang = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Question = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: 26,
      }}
      onClick={() => {
        window.open('https://pro.ant.design/docs/getting-started');
      }}
    >
      <QuestionCircleOutlined />
    </div>
  );
};

export const SwitchTheme = () => {
  const { setInitialState } = useModel('@@initialState');
  return (
    <>
      <Switch
        checkedChildren={`🌜`}
        unCheckedChildren={`🌞`}
        style={{
          padding: 0,
          borderRadius: '5vh'
        }}
        onChange={(value) => {
          const themeValue = value ? 'realDark' : 'light'
          if (themeValue === 'realDark') {
            document.body.classList.add('gstc--dark')
          } else {
            document.body.classList.remove('gstc--dark')
          }
          setInitialState((s) => ({
            ...s,
            settings: {
              ...s?.settings,
              navTheme: themeValue
            }
          })).then(() => {
            localStorage.setItem('navTheme', themeValue)
          })
        }}
      />
    </>
  )
}